import type { FaireProductEntity } from "../../entity_types/product";

export const p_2y98aka769: FaireProductEntity = {
  token: "p_2y98aka769",
  type: "product",
  name: "Huckleberry Cheesecake Gourmet Popcorn - best seller",
  brandToken: "b_pffy5dqdsz",
  brandName: "Bombshell Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/a0e2713dfde2965750e42a458ede3fc931d54f42feb96413f84bcbc6cf4467ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c25cbd9561a814fda62ab6e04218a85b708f3b6df56e78d928656ba51f0f87e9.jpeg",
    "https://cdn.faire.com/fastly/a8cbdfa3689090aea301439113c16a3fa5a457f8a27633f346d0213eaab3c241.jpeg",
    "https://cdn.faire.com/fastly/684305b0aebec5d5fb5361250aac0f327b47fbf68cee0d13dc431f9c58ceef19.png",
  ],
  priceDollars: 5.2,
  description:
    "This decadent blend brings together the creamy richness of cheesecake with the fruity tang of huckleberry. The cream and purple popcorn delivers a swirl of indulgent flavors that feels like dessert in every bite. A gourmet treat that highlights regional flair with a playful twist.\nA top seller!",
  tags: [],
  msrpDollars: 9.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:39.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
